import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';

exports.orderedChannelKeys = enabledChannels => SideBarObjects.map((o) => {
    if (o.channel && enabledChannels.indexOf(o.channel) !== -1) {
        return o.channel;
    }
    return null;
}).filter(k => k);



// WEBPACK FOOTER //
// ./src/helpers/orderedChannelKeys.js